import { render } from "./LawExams.vue?vue&type=template&id=54fab8d5"
import script from "./LawExams.vue?vue&type=script&lang=js"
export * from "./LawExams.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__